import AwesompleteWrapper from './wrapper'

export const bind = () => {
  return new AwesompleteWrapper('js-typeahead')
}
